/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MultipleChoiceExerciseSummary_exercise = {
    readonly content: {
        readonly prompt: string;
        readonly choices: ReadonlyArray<{
            readonly text: string;
            readonly isCorrect: boolean;
        }>;
    };
    readonly " $refType": "MultipleChoiceExerciseSummary_exercise";
};
export type MultipleChoiceExerciseSummary_exercise$data = MultipleChoiceExerciseSummary_exercise;
export type MultipleChoiceExerciseSummary_exercise$key = {
    readonly " $data"?: MultipleChoiceExerciseSummary_exercise$data;
    readonly " $fragmentRefs": FragmentRefs<"MultipleChoiceExerciseSummary_exercise">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "MultipleChoiceExerciseSummary_exercise",
  "type": "MultipleChoiceExercise",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "content",
      "storageKey": null,
      "args": null,
      "concreteType": "MultipleChoiceExerciseContent",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "prompt",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "choices",
          "storageKey": null,
          "args": null,
          "concreteType": "MultipleChoiceExerciseChoice",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "text",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isCorrect",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '800bbc00cc96ddf8e18f3015e2a96131';
export default node;
